<div class="menu_main_div_wrapper">
    <div class="toolbarPdf no-print">
        <div class="toolbar-left">
            <label>
                <input type="checkbox" [(ngModel)]="selectedFields.description" (change)="onOptionsChange()" />
                Menu Description
            </label>

            <label>
                <input type="checkbox" [(ngModel)]="selectedFields.allergens" (change)="onOptionsChange()" />
                Allergens
            </label>

            <label>
                <input type="checkbox" [(ngModel)]="selectedFields.vegetarian" (change)="onOptionsChange()" />
                Vegetarian
            </label>

            <label>
                <input type="checkbox" [(ngModel)]="selectedFields.vegan" (change)="onOptionsChange()" />
                Vegan
            </label>

            <label>
                <input type="checkbox" [(ngModel)]="selectedFields.price" (change)="onOptionsChange()" />
                Price
            </label>

            <label>
                <input type="checkbox" [(ngModel)]="selectedFields.ratings" (change)="onOptionsChange()" />
                Ratings
            </label>

            <div style="flex-basis: 100%">
                <textarea name="allergenMsg" id="allergenMsg" class="form-control" [(ngModel)]="allergenMsg"
                    placeholder="Please give appropriate food allergy message"></textarea>
            </div>

        </div>

        <button class="download-btn" (click)="downloadPdf()">
            Download PDF
        </button>


    </div>

    <div class="pdf-document">
        <div #pageRef class="pdf-page" *ngFor="let page of pages; let pageIndex = index">
            <div class="page-inner" [style.--footer-reserved-height.px]="footerReservedHeight">
                <img class="page-border-image" src="../../../assets/img/boder_pdf_menu.svg" alt="" />

                <div class="page-shell">
                    <div class="page-header">
                        <div class="menu-heading-left">
                            <div class="menu-title-left">
                                <div class="logo-box">
                                    <img [src]="restaurantLogo" alt="">
                                </div>
                                <div>
                                    <span class="partner-name">Powered by</span>
                                    <span style="font-size: 12px;">
                                        FOODBUD
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="brand-center">
                            <div class="logo-group">
                                <!-- <div class="logo-box">LOGO</div> -->
                                <div class="restaurant-brand">
                                    <div class="restaurant-name">{{ restaurantName }}</div>
                                    <!-- <div class="partner-name">Hemingford Grey</div> -->
                                </div>
                            </div>

                            <!-- <div class="separator-line"></div>

                            <div class="partner-brand">
                                <div class="partner-logo-box">fb</div>
                                <div class="partner-brand-name">{{ partnerName }}</div>
                            </div> -->
                        </div>

                        <div class="qr-block">
                            <div class="qr-box">
                                <img [src]="qrCode" alt="" />
                            </div>
                            <div class="qr-text">
                                Scan the QR code for a personalised menu<br />
                                based on your dietary preferences
                            </div>
                        </div>
                    </div>

                    <div class="header-line with-diamond"></div>

                    <div class="page-content">
                        <div class="columns">
                            <!-- left column -->
                            <div class="column">
                                <ng-container *ngFor="let block of page.leftColumn; let i = index">
                                    <div *ngIf="block.type === 'section'" class="section-title">
                                        {{ block.title }}
                                    </div>

                                    <div *ngIf="block.type === 'item'" class="menu-item">
                                        <div class="item-row">
                                            <div class="item-title-wrap">
                                                <span class="item-name">{{ block.item.name }}</span>

                                                <span class="item-badges"
                                                    *ngIf="(selectedFields.vegetarian && block.item.vegetarian) || (selectedFields.vegan && block.item.vegan || selectedFields.allergens)">
                                                    <span *ngIf="selectedFields.vegetarian && block.item.vegetarian"
                                                        class="tag veg">
                                                        (v)
                                                    </span>
                                                    <span *ngIf="selectedFields.vegan && block.item.vegan"
                                                        class="tag vegan">
                                                        (vg)
                                                    </span>
                                                    <span *ngIf="selectedFields.vegan && block.item.vegan && getVeganOption(block.item.dish_dpo)"
                                                        class="tag veganopt">
                                                        (vgo)
                                                    </span>
                                                    <ng-container
                                                        *ngIf="selectedFields.allergens && block.item.allergens?.length">
                                                        <ng-container *ngFor="let a of block.item.allergens">
                                                            <span class="tag" [style.color]="getTagDetails(a).color">
                                                                ({{ getTagDetails(a).code }})
                                                            </span>
                                                        </ng-container>

                                                    </ng-container>

                                                </span>
                                            </div>

                                            <div class="item-price"
                                                *ngIf="selectedFields.price && block.item.price !== undefined">
                                                {{ formatPrice(block.item.price) }}
                                            </div>
                                        </div>

                                        <div class="item-description"
                                            *ngIf="selectedFields.description && block.item.description">
                                            {{ block.item.description }}
                                        </div>

                                        <!-- <div class="item-allergens"
                                            *ngIf="selectedFields.allergens && block.item.allergens?.length">
                                            <span class="label">Allergens:</span>
                                            {{ block.item.allergens.join(', ') }}
                                        </div> -->

                                        <div class="item-rating"
                                            *ngIf="selectedFields.ratings && block.item.rating !== undefined">
                                            <span class="label">Ratings:</span>
                                            {{ block.item.rating }}/5
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- right column -->
                            <div class="column">
                                <ng-container *ngFor="let block of page.rightColumn; let i = index">
                                    <div *ngIf="block.type === 'section'" class="section-title">
                                        {{ block.title }}
                                    </div>

                                    <div *ngIf="block.type === 'item'" class="menu-item">
                                        <div class="item-row">
                                            <div class="item-title-wrap">
                                                <span class="item-name">{{ block.item.name }}</span>

                                                <span class="item-badges"
                                                    *ngIf="(selectedFields.vegetarian && block.item.vegetarian) || (selectedFields.vegan && block.item.vegan)">
                                                    <span *ngIf="selectedFields.vegetarian && block.item.vegetarian"
                                                        class="tag veg">
                                                        (v)
                                                    </span>
                                                    <span *ngIf="selectedFields.vegan && block.item.vegan"
                                                        class="tag vegan">
                                                        (vg)
                                                    </span>
                                                    <span *ngIf="selectedFields.vegan && block.item.vegan &&getVeganOption(block.item.dish_dpo)"
                                                        class="tag veganopt">
                                                        (vgo)
                                                    </span>

                                                    <ng-container
                                                        *ngIf="selectedFields.allergens && block.item.allergens?.length">
                                                        <ng-container *ngFor="let a of block.item.allergens">
                                                            <span class="tag" [style.color]="getTagDetails(a).color">
                                                                ({{ getTagDetails(a).code }})
                                                            </span>
                                                        </ng-container>

                                                    </ng-container>
                                                </span>
                                            </div>

                                            <div class="item-price"
                                                *ngIf="selectedFields.price && block.item.price !== undefined">
                                                {{ formatPrice(block.item.price) }}
                                            </div>
                                        </div>

                                        <div class="item-description"
                                            *ngIf="selectedFields.description && block.item.description">
                                            {{ block.item.description }}
                                        </div>

                                        <div class="item-allergens"
                                            *ngIf="selectedFields.allergens && block.item.allergens?.length">
                                            <span class="label">Allergens:</span>
                                            {{ block.item.allergens.join(', ') }}
                                        </div>

                                        <div class="item-rating"
                                            *ngIf="selectedFields.ratings && block.item.rating !== undefined">
                                            <span class="label">Ratings:</span>
                                            {{ block.item.rating }}/5
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="bottom-info-box" [style.height.px]="footerReservedHeight"
                        [style.min-height.px]="footerReservedHeight"
                        [ngClass]="{'grid_single': !((selectedFields.allergens && allergensDietary.length) || selectedFields.vegetarian || selectedFields.vegan)}">
                        <div class="bottom-info-left">
                            {{allergenMsg}}
                        </div>

                        <div class="bottom-info-right" *ngIf="(selectedFields.allergens && allergensDietary.length )|| selectedFields.vegetarian || selectedFields.vegan">
                            <div class="legend-grid">
                                <div *ngIf="selectedFields.vegetarian"><span class="legend-code veg" >(v)</span> - Vegetarian</div>
                                <div *ngIf="selectedFields.vegan"><span class="legend-code vegan" >(vg)</span> - Vegan</div>
                                <div *ngIf="selectedFields.vegan"><span class="legend-code veganopt" >(vgo)</span> - Vegan option available</div>
                                <ng-container *ngIf="(selectedFields.allergens && allergensDietary.length)">
                                    <ng-container *ngFor="let item of allergensDietary">
                                        <div><span class="legend-code" [style.color]="item.color">{{item.code}}</span>
                                            - {{item.name}}</div>
                                    </ng-container>
                                </ng-container>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>





    <!-- LOADER -->
    <div class="loader_wrapper" *ngIf="loader">
        <div class="loader"></div>
    </div>
</div>

<div #measureHost class="measure-host"></div>